<template>
  <yxt-select
    ref="catalogSelection"
    v-model="selectedValue"
    style="width: 144px;"
    size="small"
    :placeholder="placeholder"
    popper-class="gwnl-suffix__bg--white"
    clearable
    @change="hangleChanged"
  >
    <yxt-option
      v-for="templateType in list"
      :key="templateType.id"
      :label="templateType.name"
      :value="templateType.id"
    />
  </yxt-select>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String]
    },
    placeholder: {
      type: String
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      selectedValue: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function(val) {
        this.selectedValue = val;
      }
    }
  },
  methods: {
    hangleChanged(newVal) {
      this.$emit('input', newVal);
      this.$emit('change');
    }
  }
};
</script>
